/**
 * Keeps Shopify search queries as normal customer-entered text.
 *
 * Examples:
 * Neon stays Neon
 * Neon 100ml stays Neon 100ml
 * Neon Blue 200ml stays Neon Blue 200ml
 *
 * Older title-based URLs are automatically cleaned.
 */

const SEARCH_FORM_SELECTOR = 'form[action*="/search"]';
const TITLE_OPERATOR_PATTERN =
  /title\s*:\s*["']((?:\\.|[^"'\\])*)["']/gi;

function decodeSearchValue(value) {
  return value.replace(/\\([\\"])/g, '$1');
}

function hasTitleOperators(value) {
  TITLE_OPERATOR_PATTERN.lastIndex = 0;

  const result = TITLE_OPERATOR_PATTERN.test(
    String(value || '')
  );

  TITLE_OPERATOR_PATTERN.lastIndex = 0;

  return result;
}

function cleanSearchTerm(value) {
  const query = String(value || '').trim();

  if (!query) return '';

  TITLE_OPERATOR_PATTERN.lastIndex = 0;

  const matches = [
    ...query.matchAll(TITLE_OPERATOR_PATTERN)
  ];

  if (matches.length) {
    return matches
      .map((match) => decodeSearchValue(match[1]))
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  return query
    .replace(/^["']|["']$/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function upsertHiddenInput(form, name, value) {
  let input = form.querySelector(
    `input[name="${CSS.escape(name)}"]`
  );

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.append(input);
  }

  input.value = value;
}

function prepareSearchForm(form) {
  if (!(form instanceof HTMLFormElement)) return;

  const queryInput = form.querySelector(
    'input[name="q"]'
  );

  if (!(queryInput instanceof HTMLInputElement)) {
    return;
  }

  const cleanQuery = cleanSearchTerm(
    queryInput.value
  );

  if (!cleanQuery) return;

  /*
   * Keep the normal customer search text.
   * Do not add title: operators.
   */
  queryInput.value = cleanQuery;

  upsertHiddenInput(form, 'type', 'product');

  upsertHiddenInput(
    form,
    'options[prefix]',
    'last'
  );

  upsertHiddenInput(
    form,
    'sort_by',
    'relevance'
  );
}

function cleanLegacySearchUrl() {
  const url = new URL(window.location.href);
  const rawQuery = url.searchParams.get('q');

  if (
    url.pathname !== '/search' ||
    !rawQuery ||
    !hasTitleOperators(rawQuery)
  ) {
    return false;
  }

  const cleanQuery = cleanSearchTerm(rawQuery);

  if (!cleanQuery) return false;

  url.searchParams.set('q', cleanQuery);
  url.searchParams.set('type', 'product');

  url.searchParams.set(
    'options[prefix]',
    'last'
  );

  url.searchParams.set(
    'sort_by',
    'relevance'
  );

  url.searchParams.delete('page');

  window.location.replace(url.toString());

  return true;
}

function showCleanSearchText() {
  const url = new URL(window.location.href);

  const cleanQuery = cleanSearchTerm(
    url.searchParams.get('q')
  );

  if (!cleanQuery) return;

  document
    .querySelectorAll(
      `${SEARCH_FORM_SELECTOR} input[name="q"]`
    )
    .forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.value = cleanQuery;
      }
    });
}

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches(SEARCH_FORM_SELECTOR)
    ) {
      return;
    }

    prepareSearchForm(form);
  },
  true
);

if (!cleanLegacySearchUrl()) {
  showCleanSearchText();
}